module.exports = __webpack_public_path__ + "img/adventurecave.0e8b8892.jpg";